"use strict";
/**
 * CV-related constants
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_ACCENT_DEFAULTS = exports.DEFAULT_TEMPLATE_ID = exports.DEFAULT_ACCENT_COLOR = void 0;
/**
 * Default accent color for CV templates when not specified
 */
exports.DEFAULT_ACCENT_COLOR = '#00B48A';
/**
 * Default CV template ID when not specified
 */
exports.DEFAULT_TEMPLATE_ID = 'classic';
/**
 * Default accent colors per template
 */
exports.TEMPLATE_ACCENT_DEFAULTS = {
    classic: exports.DEFAULT_ACCENT_COLOR,
    september: exports.DEFAULT_ACCENT_COLOR,
    onepage: exports.DEFAULT_ACCENT_COLOR,
    ciblijob: '#00B48A',
    'json-elegant': exports.DEFAULT_ACCENT_COLOR,
    'json-flat': exports.DEFAULT_ACCENT_COLOR,
    'json-executive-slate': exports.DEFAULT_ACCENT_COLOR,
    'json-modern-classic': exports.DEFAULT_ACCENT_COLOR,
    'json-stackoverflow': exports.DEFAULT_ACCENT_COLOR,
};
